import React, { FunctionComponent } from 'react'
import Svg, { Path, Rect } from 'react-native-svg'

/**
 * Play button with a white circle background, used on top of thumbnails
 */
export const WhiteCirclePlayIcon: FunctionComponent<WhiteCirclePlayIconProps> = ({ size = 44 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 44 44' fill='none'>
      <Rect width='44' height='44' rx='22' fill='white' fillOpacity='0.8' />
      <Path
        d='M18.2764 15.083C18.8826 14.8319 19.6069 14.8907 20.1445 15.2344L29.1572 20.9971C29.5982 21.279 29.8574 21.717 29.8574 22.1816C29.8574 22.6463 29.5981 23.0843 29.1572 23.3662L20.1445 29.1289C19.6068 29.4727 18.8827 29.5305 18.2764 29.2793C17.67 29.028 17.2861 28.5101 17.2861 27.9434V16.419C17.2862 15.8523 17.6701 15.3343 18.2764 15.083Z'
        fill='#06163B'
      />
    </Svg>
  )
}

type WhiteCirclePlayIconProps = {
  size?: number
}
